/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  accessAPI,
  Boton,
  Titulo,
  Formulario,
  Sidebar,
  tituloBase,
  TablaFiltrable
} from "../../../../shared";
import { Toast } from "primereact/toast";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Skeleton } from "primereact/skeleton";

const SEARCH_FIELDS = ["etiqueta"];

export default function Normas() {
  const [loader, setLoader] = useState(true);
  const [normas, setNormas] = useState([]);
  const [sidebarNueva, setSidebarNueva] = useState(false);
  const [loaderNueva, setLoaderNueva] = useState(false);

  const toast = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Normas";
    accessAPI(
      "GET",
      "admin/norma",
      null,
      (respuesta) => {
        setNormas(respuesta);
        setLoader(false);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar normas",
          sticky: true
        });
        setLoader(false);
      }
    );
    return () => (document.title = tituloBase());
  }, []);

  function crearNormaSubmit(camposFormulario) {
    setLoaderNueva(true);
    accessAPI(
      "POST",
      "admin/norma",
      camposFormulario,
      (respuesta) => {
        setLoaderNueva(false);
        setSidebarNueva(false);
        navigate(`/norma/${respuesta.id}`);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al crear norma",
          sticky: true
        });
        setLoaderNueva(false);
      }
    );
  }

  const crearNormaFormConfig = {
    secciones: [
      {
        campos: [
          {
            nombre: "numero",
            tipoitemformularioid: 1,
            etiqueta: "Número",
            requerido: true
          },
          {
            nombre: "nombre",
            tipoitemformularioid: 1,
            etiqueta: "Nombre",
            requerido: true
          },
          {
            nombre: "nombrecertificado",
            tipoitemformularioid: 1,
            etiqueta: "Nombre en el certificado",
            requerido: true
          }
        ]
      }
    ],
    botones: [
      { etiqueta: "Crear norma", callback: crearNormaSubmit, validar: true }
    ]
  };

  const onRowClick = (e) => {
    if (e.originalEvent.metaKey || e.originalEvent.ctrlKey) {
      window.open(`/norma/${e.data.value}`, "_blank");
    } else {
      navigate(`/norma/${e.data.value}`);
    }
  };

  return (
    <>
      <Toast ref={toast} position="top-center" />

      {loader && (
        <div>
          <div
            css={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "2em",
              marginBottom: "1em"
            }}
          >
            <Skeleton width="10rem" height="2.5rem" />
            <Skeleton width="120px" height="2.5rem" borderRadius="6px" />
          </div>
          <Card>
            <div css={{ display: "flex", justifyContent: "flex-end", marginBottom: "0.5em" }}>
              <Skeleton width="33%" height="2.5rem" />
            </div>
            <div css={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
              <Skeleton width="100%" height="3rem" />
              {[...Array(5)].map((_, i) => (
                <Skeleton key={i} width="100%" height="3.5rem" />
              ))}
            </div>
          </Card>
        </div>
      )}

      {!loader && (
        <div>
          <Titulo
            urlVolver="/config"
            botones={
              <Boton callback={() => setSidebarNueva(true)}>
                Nueva norma
              </Boton>
            }
          >
            Normas
          </Titulo>

          <Card>
            <TablaFiltrable
              value={normas}
              searchFields={SEARCH_FIELDS}
              anchoBusqueda="33%"
              nombreArchivo="normas"
              emptyMessage="No hay normas"
              onRowClick={onRowClick}
              rows={10}
              css={{
                "& .p-datatable-tbody > tr": { cursor: "pointer" }
              }}
            >
              <Column header="Nombre" field="etiqueta" />
            </TablaFiltrable>
          </Card>
        </div>
      )}

      <Sidebar
        visible={sidebarNueva}
        onHide={() => setSidebarNueva(false)}
        position="right"
        className="w-full lg:w-30rem md:w-30rem"
      >
        <h2>Nueva norma</h2>
        <Formulario config={crearNormaFormConfig} loader={loaderNueva} />
      </Sidebar>
    </>
  );
}
